import * as React from "react"
import { SaTitle } from "../saTitle/saTitle"
// @ts-ignore
import {  saExperts, saExpertsTitleContainer,saGrid,saExpertsGrid, saExpertsText, saExpertsSliderItem,saLink,saExpertsSliderItemInner,saExpertsSlider,saExpertsSliderItemImage, saExpertsSliderItemLogo,saExpertsSliderItemName,saExpertsSliderItemPosition,saExpertsSliderItemTag,saExpertsSliderItemLocation, btnPrev, btnNext, saExpertsTitle  } from "./saExperts.module.scss"

import { saInterfaceExpertsContainer } from "../saTypes"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SaExpertsList } from "./saExpertsList"




export const SaExpertsGrid:React.FC<saInterfaceExpertsContainer> = ({...props}) => {




      return (
        <div className={'saContainer ' + saExperts}>

          {
            props.sectionTitle &&
            <div className={saExpertsTitleContainer}>
              <SaTitle title={props.sectionTitle}
                       classes={saExpertsTitle}/>
            </div>
          }

          {
            props.text &&
            <div className={saExpertsText}
                 dangerouslySetInnerHTML={{__html: props.text}} />
          }

          <div className={saExpertsGrid}>

            <SaExpertsList {...props.relationship} />

          </div>

        </div>
      )


}
